export default "__VITE_ASSET__BRyEUypP__ 400w, __VITE_ASSET__C0$kHHS___ 800w, __VITE_ASSET__BD4HjK19__ 1024w";